
function isInputFunctionValidation(obj: InputFunctionValidation | InputRegexValidation): obj is InputFunctionValidation {
    return !!(obj as InputFunctionValidation).isValid;
}

export interface InputFunctionValidation {
    isValid: (text: string) => boolean;
    errorKey: string;
}

export interface InputRegexValidation {
    requirements: RegExp;
    exclusions: RegExp;
    errorKey: string;
}

export class InputValidationModel {
    validationOption: InputFunctionValidation | InputRegexValidation;
    errorKey: string = 'validationFunctionError';

    constructor(validationOption: InputFunctionValidation | InputRegexValidation) {
        this.validationOption = validationOption;
        this.errorKey = this.validationOption.errorKey;
    }

    public isValid(text: string): boolean {
        if (isInputFunctionValidation(this.validationOption)) {
            return this.validationOption.isValid(text);

        } else {
            return this.isValidRegex(text);
        }
    }

    /**
     * Determines whether or not the supplied text is valid
     * based on this set of requirements and exclusions
     */
    private isValidRegex(text: string): boolean {
        const { requirements, exclusions } = (this.validationOption as InputRegexValidation);
        const hasRequirements: boolean = requirements instanceof RegExp;
        const hasExclusions: boolean = exclusions instanceof RegExp;
        let passesRequirements: boolean = true;
        let violatesExclusions: boolean = false;
        let isValid: boolean = true;

        if (hasRequirements) {
            passesRequirements = requirements.test(text);
        }

        if (hasExclusions) {
            violatesExclusions = exclusions.test(text);
        }

        isValid = passesRequirements && !violatesExclusions;

        return isValid;
    }
}
